import './ActiveConnections.scss'
import PropTypes from 'prop-types';
import { useState, useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { Pager } from '@progress/kendo-react-data-tools';
import { get, put } from '../utils/requests';
import { showMsg } from '../utils/logger';
import { dateToStr } from '../utils/convert';
import Button from '../buttons/Button';
import Tooltip from '../forms/Tooltip';
import Dialog from '../dialogs/Dialog';

import { _connection } from './User';


/**
 * Riadok s konekciou v dialogu konekcii pouzivatela
 * @param {*} param0 
 */
const Connection = ({ connection, getActiveConnections }) => {
  const dispatch = useDispatch();
  const connectionId = _connection?.id ?? "";

  const logOut = async () => {
    try {
      let res = await put(`/api/meta/connections/${connection.PrihlId}/logout`);
      if (res?.Data) {
        dispatch(showMsg("Odhlásenie prebehlo úspešne"));
      } else {
        dispatch(showMsg("Odhlásenie sa nepodarilo", "warning"));
      }
    } catch (error) {
      dispatch(showMsg("Chyba pri pokuse o odhlásenie", "error"));
    }
    await getActiveConnections();
  }

  return (
    <div className={`row active-conn-regular`}>
      <div className='col col-md-4 active-conn-text'>{connection.PrihlId}</div>
      <div className='col col-md-3 active-conn-text'>{connection.PrehlInfo}</div>
      <div className='col col-md-3 active-conn-date'>{dateToStr(connection.DPrihl)}</div>
      {connection.PrihlId === connectionId ?
        <div className='col col-md-2 active-conn-icon'>{connection.PrihlId === connectionId ? "(Toto zariadenie)" : ""}</div>
        :
        <div className='col col-md-2 active-conn-read active-conn-icon' onClick={logOut} title='Odhlásiť'>
          {connection.PrihlId !== connectionId &&
            <Tooltip parentTitle={true}>
              <span className={`k-icon k-font-icon k-i-logout`}></span>
            </Tooltip>
          }
        </div>
      }
    </div>
  )
}



/**
 * Dialog s aktivnymi prihlaseniami pouzivatela
 * @param {*} props 
 */
export const ActiveConnectionsDialog = (props) => {
  const { isOpen, onClose } = props;
  const dispatch = useDispatch();
  const [skip, setSkip] = useState(0);
  const [connections, setConnections] = useState({ TotalRecords: 0, Items: [] });

  const handlePageChange = (event) => {
    const { skip } = event;
    setSkip(skip);
  };

  // Ziska aktivne konekcie
  const getActiveConnections = async () => {
    try {
      const connections = await get(`/api/meta/connections/active?page=${(skip / 10) + 1}`);
      setConnections(connections.Data);
    } catch (error) {
      dispatch(showMsg("Nepodarilo sa získať zoznam aktívnych prihlásení", "warning"));
    }
  }

  const logOutAll = async () => {
    try {
      let res = await put(`/api/meta/connections/${_connection?.id ?? ""}/logout-all`);
      if (res?.Data) {
        dispatch(showMsg("Odhlásenie prebehlo úspešne"));
      } else {
        dispatch(showMsg("Odhlásenie sa nepodarilo", "warning"));
      }
    } catch (error) {
      dispatch(showMsg("Chyba pri pokuse o odhlásenie", "error"));
    }
    await getActiveConnections();
  }

  useEffect(() => {
    getActiveConnections();
  }, [skip]); // eslint-disable-line

  return (
    <Dialog
      isOpen={isOpen}
      onClose={onClose}
      title="Moje aktívne prihlásenia"
      width="70%"
      hideButtons
    >
      <div className='active-conn-dialog'>
        <div className='row active-conn-settings'>
          <div className='col active-conn-mark-all-read'>
            <Button label={`Odhlásiť sa zo všetkých zariadení okrem tohto`} icon={"logout"} disabled={connections === null || connections?.TotalRecords <= 1} onClick={logOutAll} primary={true} />
          </div>
        </div>
        <div className='row active-conn-regular active-conn-title'>
          <div className='col col-md-4'>Identifikátor</div>
          <div className='col col-md-3'>Prehliadač</div>
          <div className='col col-md-3'>Dátum a čas prihlásenia</div>
          <div className='col col-md-2'></div>
          {/* <div className='col col-md-1'></div> */}
        </div>
        {connections?.TotalRecords > 0
          ?
          connections?.Items?.map(conn => <Connection connection={conn} getActiveConnections={getActiveConnections} key={conn.IUzPrihl} />)
          :
          <div className='active-conn-empty'>Nemáte žiadne aktívne prihlásenia</div>
        }
        <hr />
        <Pager
          skip={skip}
          take={10}
          total={connections?.TotalRecords ?? 0}
          buttonCount={5}
          info={true}
          type='numeric'
          previousNext={true}
          responsive={true}
          onPageChange={handlePageChange}
        />
      </div>
    </Dialog>
  )
}

ActiveConnectionsDialog.propTypes = {
  isOpen: PropTypes.bool,
  onClose: PropTypes.func
}